import "../styles/EncartActualite.css";
import { Link } from "react-router-dom";
import gif from "../assets/deshabille.gif";

function EncartActualite() {
    return(
        <div className="banner-actualite-frame">
            <img src={gif} className="actualite-img actualite-img-gauche"></img>
            <div className="actualite-para">Psssst... on a trouvé le cadeau parfait pour surprendre (et se faire plaisir) !   
            <Link to="/coffret-cadeau"><button className="actualite-btn">Découvre ça ici</button></Link></div>
            <img src={gif} className="actualite-img actualite-img-droite"></img>
        </div>
    )
}

export default EncartActualite;